import type { SagaReturnType } from 'redux-saga/effects';
import { put, select, takeLatest } from 'redux-saga/effects';

import { api } from 'src/api';
import { getHotelId } from 'src/routes/Hotel/store/selectors/hotel';
import { INIT_APP } from '../view/constants';
import { getReviewsPage, getReviewsVisible } from './selectors';
import {
  setReviews,
  setReviewsPage,
  setReviewsTotalCount,
  showMoreReviews,
  setVisibleCount,
  setLoadingNewReviews,
  setReviewsData,
  setVariant,
} from './slice';
import { getIsMobile } from '../view/selectors';

function* initialDownloadReviews() {
  const url = new URL(window.location.href);
  const value = url.searchParams.get('ab_hotel_reviews');
  if (value === 'new') {
    yield put(setVariant('new'));
    yield getNewHotelReviews();
  } else {
    yield getOldHotelReviews();
  }
}

/**
 * Загрузить старые отзывы отеля
 */
function* getOldHotelReviews() {
  try {
    const hotelId: SagaReturnType<typeof getHotelId> = yield select(getHotelId);
    const response: SagaReturnType<typeof api.getReferencesHotelReviews> =
      yield api.getReferencesHotelReviews(Number(hotelId));
    if (response.success && response.reviews) {
      yield put(setReviewsData(response.reviews));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

/**
 * Загрузить новые отзывы отеля
 */
function* getNewHotelReviews() {
  try {
    const hotelId: SagaReturnType<typeof getHotelId> = yield select(getHotelId);
    const currentPage: SagaReturnType<typeof getReviewsPage> = yield select(
      getReviewsPage,
    );
    const isMobile = yield select(getIsMobile);
    const perPage = isMobile ? 3 : 10;
    const params = { perPage, page: currentPage };
    const response: SagaReturnType<typeof api.getHotelReview> =
      yield api.getHotelReview(Number(hotelId), params);
    if (response.success && response.reviews) {
      yield put(setReviews(response.reviews));
      yield put(setReviewsTotalCount(response.pagination.total));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

function* downloadMoreReviews() {
  const currentPage: SagaReturnType<typeof getReviewsPage> = yield select(
    getReviewsPage,
  );
  const visibleCount = yield select(getReviewsVisible);
  yield put(setReviewsPage(currentPage + 1));
  yield put(setVisibleCount(visibleCount + 10));
  yield put(setLoadingNewReviews(true));
  yield getNewHotelReviews();
  yield put(setLoadingNewReviews(false));
}

export default function* reviewSaga() {
  yield takeLatest(INIT_APP, initialDownloadReviews);
  yield takeLatest(showMoreReviews, downloadMoreReviews);
}
